// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Button, Table } from "antd";
// import {
//   Avatar_06,
//   Avatar_07,
//   Avatar_14,
//   Avatar_18,
//   Avatar_19,
//   Avatar_22,
//   Avatar_26,
//   Avatar_29,
// } from "../../../Routes/ImagePath";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// // import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
// import SearchBox from "../../../components/SearchBox";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// // import ClientsFilter from "../../../components/ClientsFilter";
// import { FileLoginModalPopup } from "./FileLoginModalPopup";
// import FileLoginFilter from "./FileLoginFilter";
// import axios from "axios";
// import { Api_Url } from "../../../config/config";
// import moment from "moment";

// const FileLoginList = () => {
//   const [tableData, setTableData] = React.useState([]);

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem("user"))?.id;
//       // console.log("id", id)
//       const response = await axios.get(
//         `${Api_Url}api/v1/FileLogin?UserId=${id}&PageNumber=1&PageSize=100`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       console.log("response", response.data?.data)
//       setTableData(response?.data?.data);
//     } catch (error) {
//       return error;
//     }
//   };

//   useEffect(() => {
//     AllFileLoginData();
//   }, []);

//   const [deleteId, setdeleteId] = useState(null);

//   const handleDeleteData = async () => {
//     console.log("iddddd", deleteId);
//     try {
//       const response = await axios.delete(
//         `${Api_Url}api/v1/FileLogin/${deleteId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//           },
//         }
//       );
//       console.log("res", response);
//       AllFileLoginData();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const [editId, setEditId] = useState(null);

//   const handleEditData = async (id) => {
//     setEditId(id);
//     // try {
//     //   const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//     //     headers: {
//     //       Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//     //     }
//     //   })
//     //   console.log("response", response.data)
//     //   setTableData(response.data)
//     // } catch (error) {
//     //   return error
//     // }
//   };

//   const columns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       render: (text, record) => (
//         <span className="table-avatar">
//           <Link to="/profile">{text}</Link>
//         </span>
//       ),
//     },
//     // {
//     //   title: "Client ID",
//     //   dataIndex: "ClientId",
//     //   sorter: (a, b) => a.ClientId.length - b.ClientId.length,
//     // },

//     // {
//     //   title: "Contact Person",
//     //   dataIndex: "ContactPerson",
//     //   sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
//     // },
//     {
//       title: "Branch Name",
//       dataIndex: "branchName",
//     },

//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//     },
//     {
//       title: "Application No.",
//       dataIndex: "applicationNo",
//     },
//     {
//       title: "Last Activity",
//       dataIndex: "",
//       render: (text, record) => (
//         <span className="table-avatar">
//           {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
//         </span>
//       ),
//     },
//     {
//       title: "Location",
//       dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//       render: (text, record) => (
//         <a
//           href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <i class="fa-solid fa-location-dot"></i>
//         </a>
//       ),
//     },
//     // {
//     //   title: "Action",
//     //   render: (item) => (
//     //     <div className="dropdown dropdown-action text-end">
//     //       <Link
//     //         to="#"
//     //         className="action-icon dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i className="material-icons">more_vert</i>
//     //       </Link>
//     //       <div className="dropdown-menu dropdown-menu-right">
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#edit_client"
//     //           onClick={()=>handleEditData(item.id)}
//     //         >
//     //           <i className="fa fa-pencil m-r-5" /> Edit
//     //         </Link>
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#delete"
//     //           onClick={()=>setdeleteId(item.id)}
//     //         >
//     //           <i className="fa fa-trash m-r-5" /> Delete
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: true,
//     // },
//     // {
//     //   title: "Longitude",
//     //   dataIndex: "longitude",
//     //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
//     // },
//     // {
//     //   title: "Status",
//     //   dataIndex: "Status",
//     //   render: (text) => (
//     //     <div className="dropdown">
//     //       <Link
//     //         to="#"
//     //         className="btn btn-white btn-sm btn-rounded dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i
//     //           className={
//     //             text === "Active"
//     //               ? "far fa-dot-circle text-success"
//     //               : "far fa-dot-circle text-danger"
//     //           }
//     //         />{" "}
//     //         {text}{" "}
//     //       </Link>
//     //       <div className="dropdown-menu">
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-success" /> Active
//     //         </Link>
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-danger" /> Inactive
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: (a, b) => a.Status.length - b.Status.length,
//     // },
//   ];

//   const handleAddUser = (newUser) => {
//     setTableData([...tableData, newUser]);
//   };

//   // const columns = [
//   //   {
//   //     title: "Name",
//   //     dataIndex: "userName",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         <Link to="/profile" className="avatar">
//   //           <img alt="" src={record.selfieUrl} />
//   //         </Link>
//   //         <Link to="/profile">{text}</Link>
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Activity",
//   //     dataIndex: "name",
//   //   },
//   //   {
//   //     title: "Branch Name",
//   //     dataIndex: "branchName",
//   //   },
//   //   {
//   //     title: "Last Activity",
//   //     dataIndex: "",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         {moment(record.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Location",
//   //     dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//   //     render: (text, record) => (
//   //       <a
//   //         href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//   //         target="_blank"
//   //         rel="noopener noreferrer"
//   //       >
//   //         <i class="fa-solid fa-location-dot"></i>
//   //       </a>
//   //     )},
//   //   {
//   //     title: "View",
//   //     dataIndex: "actions",
//   //     render: (text, record) => (
//   //       <Button className="btn-property">
//   //           <i className="fa-solid fa-eye"></i>
//   //           </Button>
//   //     ),
//   //   },
//   // ]
//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           {/* page header */}
//           <div className="page-header">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <h3 className="page-title">File Login</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/dashboard">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active">File Login</li>
//                 </ul>
//               </div>
//               <div className="col-md-8 float-end ms-auto">
//                 <div className="d-flex title-head">
//                   <div className="view-icons">
//                     <div className="form-sort">
//                       <Link to="#" className="list-view btn btn-link">
//                         <i className="las la-file-export" />
//                         Export
//                       </Link>
//                     </div>
//                   </div>
//                   <Breadcrumbs
//                     modal="#add_client"
//                     name="Add File Login"
//                     Linkname="/clients"
//                     Linkname1="/clients-list"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Page Header */}
//           {/* <Breadcrumbs
//             maintitle="File Login"
//             title="Dashboard"
//             subtitle="File login"
//             modal="#add_client"
//             name="Add File hjghjLogin"
//             Linkname="/clients"
//             Linkname1="/clients-list"
//           /> */}
//           {/* /Page Header */}
//           <FileLoginFilter />
//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <SearchBox />
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={tableData}
//                   rowKey={(record) => record.id}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <FileLoginModalPopup
//         onAddUser={FileLoginList}
//         HandleEditFunc={handleEditData}
//         AllFileLoginDat= {AllFileLoginData}
//       />
//       <DeleteModal Name="Delete Client" handleDeleteData={handleDeleteData} />
//     </>
//   );
// };

// export default FileLoginList;

// New Modal

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
// import ClientsFilter from "../../../components/ClientsFilter";
import { FileLoginModalPopup } from "./FileLoginModalPopup";
import FileLoginFilter from "./FileLoginFilter";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import moment from "moment";

const FileLoginList = () => {
  const [tableData, setTableData] = React.useState([]);

  const AllFileLoginData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      // console.log("id", id)
      const response = await axios.get(
        `${Api_Url}api/v1/FileLogin?UserId=${id}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("response", response.data?.data);
      setTableData(response?.data?.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    AllFileLoginData();
  }, []);

  const [deleteId, setdeleteId] = useState(null);

  const handleDeleteData = async () => {
    console.log("iddddd", deleteId);
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/FileLogin/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      console.log("res", response);
      AllFileLoginData();
    } catch (error) {
      console.error(error);
    }
  };

  const [editId, setEditId] = useState(null);

  const handleEditData = async (id) => {
    setEditId(id);
    // try {
    //   const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
    //     headers: {
    //       Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
    //     }
    //   })
    //   console.log("response", response.data)
    //   setTableData(response.data)
    // } catch (error) {
    //   return error
    // }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="table-avatar">
          <Link to="/profile">{text}</Link>
        </span>
      ),
    },
    // {
    //   title: "Client ID",
    //   dataIndex: "ClientId",
    //   sorter: (a, b) => a.ClientId.length - b.ClientId.length,
    // },

    // {
    //   title: "Contact Person",
    //   dataIndex: "ContactPerson",
    //   sorter: (a, b) => a.ContactPerson.length - b.ContactPerson.length,
    // },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },

    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      title: "Application No.",
      dataIndex: "applicationNo",
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
  ];

  const handleAddUser = (newUser) => {
    setTableData([...tableData, newUser]);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* page header */}
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">File Login</h3>
              <div>
                <button className="btn border me-3">
                  <Link to="#" className="list-view btn btn-link">
                    <i className="las la-file-export" />
                    Export
                  </Link>
                </button>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add File Login
                </button>
                {isModalOpen && (
                  <FileLoginModalPopup
                    onClose={handleCloseModal}
                    onAddUser={FileLoginList}
                    HandleEditFunc={handleEditData}
                    AllFileLoginDat={AllFileLoginData}
                  />
                )}
              </div>
            </div>
          </div>

          {/* <FileLoginFilter /> */}
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={tableData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <FileLoginModalPopup
        onAddUser={FileLoginList}
        HandleEditFunc={handleEditData}
        AllFileLoginDat={AllFileLoginData}
      /> */}
      <DeleteModal Name="Delete Client" handleDeleteData={handleDeleteData} />
    </>
  );
};

export default FileLoginList;
